module.exports = "/static/assets/89a6f14acf501ffda6f1e5c9e7bd8514.png";